import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import CardMenu, { type CardMenuItem } from '@ui/CardMenu'
import type { ReactElement } from 'react'

import { cellHeight } from '../styles'

export interface RowActionsMenuItem extends CardMenuItem {
  Icon?: ReactElement
}

interface RowActionsProps {
  menuItems: RowActionsMenuItem[]
  disabled?: boolean
}

/* eslint-disable sort-keys */
const RowActionContainer = styled('div')(({ theme }) => ({
  '&:hover': {
    background: 'transparent',
    color: theme.palette.divider,
  },
  '&:not(:last-child)': {
    marginBottom: -1,
  },
  borderTop: `1px solid ${theme.palette.divider}`,
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderLeft: `1px solid ${theme.palette.divider}`,
  borderRight: 'none',
  color: theme.palette.text.primary,
  background: theme.palette.background.paper,
  boxShadow: '-8px 0px 8px -4px rgba(0, 0, 0, 0.12)',
  marginLeft: '-4px',
  height: cellHeight - 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))
/* eslint-enable sort-keys */

export const RowActions = ({ menuItems, disabled }: RowActionsProps) => {
  const hasSingleMenuItem = menuItems.length === 1
  const firstMenuItem = menuItems[0]
  const handleIconClick = () => {
    firstMenuItem.onSelect()
  }

  if (!menuItems.length) {
    return null
  }

  return (
    <RowActionContainer>
      {hasSingleMenuItem && firstMenuItem.Icon ? (
        <IconButton
          data-test-id="row-action-button"
          disabled={disabled || firstMenuItem.disabled}
          onClick={handleIconClick}
          size="small"
          sx={{ padding: 1 }}
        >
          {firstMenuItem.Icon}
        </IconButton>
      ) : (
        <CardMenu
          disabled={disabled}
          menuItems={menuItems.map(({ Icon: _Icon, ...rest }) => rest)}
        />
      )}
    </RowActionContainer>
  )
}
